import React from "react";
import { Avatar } from "@material-ui/core";
import avatarDefault from "../static/avatarDefault.png";

import performRequest from "../configAxios";

export default function AbtcAvatar({ photo, imageUrl, size, style, classes, avatarStyle, hideOnlineStatus, disableLink, enablePremiumBorder }) {
  style = {
    position: "relative",
    display: "block",
    textDecoration: "none",
    ...style
  };
  avatarStyle = {
    backgroundColor: "black",
    color: "black",
    fonstWeight: "bold",
    fontSize: "5vh",
    ...avatarStyle
  };
  if (size) {
    style.width = size;
    style.height = size;
    avatarStyle.width = size;
    avatarStyle.height = size;
  }
  if (enablePremiumBorder) {
    avatarStyle.border = "2px #FFBE2D solid";
  }
  const onlineStyle = {
    position: "absolute",
    right: 0,
    bottom: 0,
    width: "30%",
    height: "30%"
  };
  return (
    <div style={style} classes={classes}>
      <InnerAvatar imageUrl={imageUrl} hideOnlineStatus={hideOnlineStatus} avatarStyle={avatarStyle} onlineStyle={onlineStyle} photo={photo} />
    </div>
  );
}

function InnerAvatar({ photo, imageUrl, hideOnlineStatus, avatarStyle, onlineStyle }) {
  const [image, setImage] = React.useState(avatarDefault);

  React.useEffect(() => {
    if (photo) {
      const src = `data:image/png;base64,${photo}`;
      setImage(src);
      return;
    }

    if (!imageUrl) return;

    let url;
    const fetchImage = async () => {
      try {
        const a = await performRequest("GET", "/public/files/" + imageUrl, null, true, null, "blob");
        url = URL.createObjectURL(a.data);
        setImage(url);
      } catch {}
    };
    fetchImage();
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [imageUrl, photo]);
  return (
    <>
      <Avatar src={image} alt={""} style={avatarStyle}>
        <svg
          viewBox="0 0 20 20"
          style={{
            fontSize: "30%",
            fontWeight: "bold",
            width: "100%",
            height: "100%",
            textTransform: "uppercase",
          }}
        >
          <text x="10" y="10.7" textAnchor="middle" alignmentBaseline="central">
            ok
          </text>
        </svg>
      </Avatar>
    </>
  );
}
